module.exports = __webpack_public_path__ + "img/support_head_mb.e57a38be.jpg";